import { gql } from "@apollo/client";

const API_KEY_FIELDS = gql`
  fragment ApiKeyFields on ApiKey {
    id
    name
    scopes
    createdAt
    createdBy {
      id
      fullName
    }
  }
`;

export const LIST_API_KEYS = gql`
  ${API_KEY_FIELDS}

  query listApiKeys {
    listApiKeys {
      ...ApiKeyFields
    }
    listApiKeyScopes
  }
`;

export const CREATE_API_KEY = gql`
  mutation createApiKey($input: CreateApiKeyInput!) {
    createApiKey(input: $input) {
      id
      name
      scopes
      secret
    }
  }
`;

export const UPDATE_API_KEY = gql`
  ${API_KEY_FIELDS}

  mutation updateApiKey($input: UpdateApiKeyInput!) {
    updateApiKey(input: $input) {
      ...ApiKeyFields
    }
  }
`;

export const DELETE_API_KEY = gql`
  mutation deleteApiKey($input: DeleteApiKeyInput!) {
    deleteApiKey(input: $input)
  }
`;
